/**
 * @file contactMap.component.tsx
 * @path apps/website/src/features/contact/components/contactMap.component.tsx
 * @description Isolated map display component.
 */

import { capeTownMap } from "@/assets/images";

export const ContactMap = () => (
  <div className="rounded-2xl overflow-hidden border border-border p-2 bg-card">
    <div className="rounded-xl overflow-hidden w-full h-[400px] relative">
      <img
        src={capeTownMap}
        alt="Map showing location in Cape Town"
        className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
      />
      <div className="absolute inset-0 bg-background/20 mix-blend-multiply pointer-events-none" />
    </div>
  </div>
);
